import PropTypes from "prop-types";
import React from "react";
// import IconBoxData from '../../data/iconBox/icon-box.json';
// import IconBox from '../../components/IconBox/IconBox.jsx';
import SectionTitle from "../../components/SectionTitles/SectionTitle";
import NewGif from "../../components/Gif/NewGif";
// import Btn2 from "../../components/Btn/Btn2";

const ServiceIconBox = ({ classOption }) => {
  return (
    <div className={`section section-padding-t90-b80 ${classOption}`}>
      <div className="container">
        <SectionTitle title="Anouncement" />

        <div className="conference-ind">

        </div>


        <div className="row row-cols-1 mb-n6" id="anounce">
          <ul className="li-align">
            <li>
              <h5>
                <div className="font-red" >
                  <a href="https://iasei.org/icsi2024/">
                    <NewGif />{" "}
                    Welcome to join ICSI&apos;2024 in Xining, Qinghai, China, August 23th-26th, 2024!
                  </a>
                </div>
              </h5>
            </li>
            <br></br>
            <li>
              <h5>
                <div className="font-red" >
                  <a href="./gallery">
                    <NewGif />{" "}
                    Congratulations! ICSI&apos;2023 has been held successfully on 14th - 18th, July! 
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div className="font-red" >
                  <a href="./gallery">
                    <NewGif />{" "}
                    Our wonderful moments!
                  </a>
                </div>
              </h5>
            </li>
            {/* <li>
              <h5>
                <div className="font-red" >
                  <a href="./proceeding">
                    <NewGif />{" "}
                    The ICSI&apos;2023 Proceedings (Springer-Nature LNCS 13968 and LNCS 13969) are available online for all participants to download, for free, from July 10, 2023 to August 10, 2023.
                  </a>
                </div>
              </h5>
            </li> */}
            <li>
              <h5>
                <div >
                  <a href="./registration_pub">
                    <del>

                                      ICSI&apos;2023 is ready for all authors and participants, welcome to our exciting conference ICSI&apos;2023!
                    </del>
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div  >
                  <a href="./registration_pub">
                    <del>
                    The public registration for ICSI&apos;2023 is now open. Everyone is welcome to register and participate in our conference!

                    </del>
                  </a>
                </div>
              </h5>
            </li>
            {/* <li>
              <h5>
                <div >
                  <a href="./competition">
                    <NewGif />{" "}
                    ICSI-OC&apos;2023: &quot;  Competition on Single Objective Bounded Optimization Problems &quot;{" "}call for participants!
                  </a>
                </div>
              </h5>

            </li> */}
            <li>
              <h5>
                <div >
                  <a href="./registration">
                    <del>
                    Author registration is open, please complete the author registration before April 25!
                    </del>
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <a href="./registration">
                    <del>
                    The notification letters for ICSI&apos;2023 submissions have been sent to the corresponding author(s) of each ICSI&apos;2023
                    submission on March 31, 2023!
                    </del>
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <a href="./topic">
                    <del>
                      ICSI&apos;2023 Call for Papers!
                    </del>
                  </a>

                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <del>
                    Deadline for Paper Submission: January 31,2023!
                  </del>
                  {/* ICSI&apos;2022 is ready for all authors and participants, welcome to our exciting conference ICSI&apos;2022! */}
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <del>
                    Final Deadline for Paper Submission: February 28, 2023 (Fixed)!
                  </del>
                  {/* ICSI&apos;2022 is ready for all authors and participants, welcome to our exciting conference ICSI&apos;2022! */}
                </div>
              </h5>
            </li>
            {/* <li>
              <h5>
              <div className="font-red">
              <NewGif />{" "}
              Final Deadline for Paper Submission: February 28, 2023 (Fixed)!
              ICSI&apos;2022 is ready for all authors and participants, welcome to our exciting conference ICSI&apos;2022!
              </div>
              </h5>
            </li> */}
            {/* <li>
              <h5>
              <div className="font-red">
              <NewGif />{" "}
              <a href="./specialsession">
              ICSI&apos;2023 call for special session proposals!
              </a>
              
              </div>
              </h5>
            </li> */}
            <br></br>


            <li>

              <h5>
                <div >
                  <a href="./specialsession#session1">
                    {" "}
                    Special Session 1: &quot;Machine Learning and Swarm Intelligence in Resource Allocation and Industrial Applications&quot;{" "}
                  </a>
                </div>
              </h5>
            </li>
            <li>
              <h5>
                <div >
                  <a href="./specialsession#session2">
                    {" "}
                    Special Session 2: &quot;Fireworks Algorithm and Its Applications&quot;{" "}
                  </a>
                </div>
              </h5>

            </li>

            <li>
              <h5>
                <div >
                  <a href="./specialsession#session3">
                    {" "}
                    Special Session 3: &quot;Cooperative Decision and Control of Swarm Intelligence&quot;{" "}
                  </a>
                </div>
              </h5>

            </li>

            <li>
              <h5>
                <div >
                  <a href="./specialsession#session4">
                    {" "}
                    Special Session 4: &quot;Large-scale Global Optimization and Applications&quot;{" "}
                  </a>
                </div>
              </h5>

            </li>

            <li>
              <h5>
                <div >
                  <a href="./specialsession#session5">
                    {" "}
                    Special Session 5: &quot;Biologically inspired Swarm Intelligence for Robotics and Mechatronics&quot;{" "}
                  </a>
                </div>
              </h5>

            </li>

            <li>
              <h5>
                <div >
                  <a href="./specialsession#session6">
                    {" "}
                    Special Session 6: &quot; Swarm Intelligence in Dynamic Optimization&quot;{" "}
                  </a>
                </div>
              </h5>

            </li>

            <li>
              <h5>
                <div >
                  <a href="./specialsession#session7">
                    {" "}
                    Special Session 7: &quot; Intelligent Decision Making in Real life applications using nature inspired optimization techniques &quot;{" "}
                  </a>
                </div>
              </h5>

            </li>
            <li>
              <h5>
                <div >
                  <a href="./specialsession#session7">
                    {" "}
                    Special Session 8: &quot; Natural-inspired Adaptive Optimization Algorithms: New Theory, New Local Structures, New Evolutionary Strategies, and New Applications &quot;{" "}
                  </a>
                </div>
              </h5>

            </li>
            <br></br>



          </ul>
        </div>
        {/* <div>
        Notice: 
        Due to the rapid overspreading of Omicron variant of COVID-19, even though the ICSI 2022 was planned to be held in a hybrid mode, after carefully evaluating most of announcements and guidance regarding to COVID-19, and too much restrictions on traveling to the venue, released by relevant national departments and Xi&apos;an municipal, the ICSI 2022 organizing committee has made the decision that our ICSI 2022 will continue as scheduled on July 15-19, by being converted to a fully virtual conference. The ICSI 2022 technical team will be providing the ability for the authors with accepted papers to present their work through an interactive online platform or video replay. The presentations of accepted authors will be made available to all registered attendees online.
        </div> */}
        <div className="conference-ind">

          {/* <div className="online-info" >
 Notice: 
Due to the rapid overspreading of Omicron variant of COVID-19, even though the ICSI 2022 was planned to be held in a hybrid mode, after carefully evaluating most of announcements and guidance regarding to COVID-19, and too much restrictions on traveling to the venue, released by relevant national departments and Xi&apos;an municipal, the ICSI 2022 organizing committee has made the decision that our ICSI 2022 will continue as scheduled on July 15-19, by being converted to a fully virtual conference. The ICSI 2022 technical team will be providing the ability for the authors with accepted papers to present their work through an interactive online platform or video replay. The presentations of accepted authors will be made available to all registered attendees online.
</div> */}
        </div>
        {/* <div className="double-sub">
          <Btn2
            name="Submit your paper!"
            linkage={process.env.PUBLIC_URL + "/submission"}
          />
          <div className="space"></div>
          <Btn
            name="Submit Chinese paper"
            linkage={process.env.PUBLIC_URL + "/submission_zn"}
          />
        </div> */}
      </div>
    </div>
  );
};

ServiceIconBox.propTypes = {
  classOption: PropTypes.string,
};
ServiceIconBox.defaultProps = {
  classOption: "section section-padding-t90-b100",
};

export default ServiceIconBox;
